import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-examinees-group',
  templateUrl: './examinees-group.component.html',
  styleUrls: ['./examinees-group.component.scss']
})
export class ExamineesGroupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
